<template lang="pug">
#content
    unit(v-bind:sidebar="sidebar")
    router-view
    site-footer
</template>

<script>
import Vue from 'vue'
import SettingTitle from './setting/component/general-title.vue'
import DomainSelect from './setting/component/domain-select.vue'
import unit from './sidebar/unit.vue'
Vue.component('setting-title', SettingTitle)
Vue.component('domain-select', DomainSelect)

export default {
  computed: {
    listEmpty () {
      return this.$store.state.domainList.length === 0
    },
    sidebar () {
      return [
        {
          title: '网站分析设置',
          iconName: 'gear',
          iconColor: '#e45f56',
          expanded: true,
          focused: false,
          links: [
            {
              to: '/setting/sites',
              name: '站点管理'
            },
            {
              to: '/setting/gencode',
              name: '代码管理',
              disabled: this.listEmpty
            },
            {
              to: '/setting/filter',
              name: '过滤规则',
              disabled: this.listEmpty
            },
            {
              to: '/setting/user',
              name: '点睛用户绑定',
              disabled: this.listEmpty
            },
            {
              to: '/setting/trans',
              name: '转化目标设置',
              disabled: this.listEmpty
            },
            {
              to: '/setting/crowdSegmentation',
              name: '人群细分设置',
              isNew: true,
              disabled: this.listEmpty
            }
          ]
        }, {
          title: '应用推广设置',
          iconName: 'gear',
          iconColor: '#AB42AE',
          expanded: true,
          focused: false,
          links: [
            {
              to: 'appuser',
              name: '点睛用户绑定'
            }
          ]
        }, {
          title: '账户管理',
          iconName: 'user',
          iconColor: '#72b774',
          expanded: true,
          focused: false,
          links: [
            {
              to: '/setting/account',
              name: '账户信息'
            }
          ]
        }
      ]
    }
  },
  components: {
    unit
  }
}
</script>



// WEBPACK FOOTER //
// setting.vue?5b7569b6